// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 height=%2714%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23595959%27 stroke-width=%272.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS UNIQUE de la case acheteur Operation MS (V2). Tout le style propre a la case vit ici,
   sous le namespace .opms. Pas de CSS par composant, pas de reutilisation des feuilles legacy
   (Consultation.css / Analyse.css / Marche.css...). Le fichier grandit au fil des onglets. */

/* Layout du shell (remplace les anciennes classes legacy suivi-commande / suivi-de-commande-content
   / tab-content qui couplaient la case au CSS legacy). Auto-suffisant : seul .opms est requis.
   Padding aligne sur la case BC (.opbc__content / .opbc__tab-content) : top a 0 pour que la barre
   d'onglets soit a la meme hauteur que le BDC. */
.opms__content {
  /* Inset 6rem comme les autres pages ; le banner (hors de ce wrapper) reste pleine largeur. */
  padding: 0 6rem 2rem 6rem;
}

/* Padding vertical + un peu d'air a gauche/droite du contenu des onglets (l'horizontal s'ajoute
   aux 2rem de .opms__content sans toucher l'alignement de la barre d'onglets ni la case BC). */
.opms__tab-content {
  padding: 2rem 1.5rem;
  min-height: 500px;
}

@media print {
  .opms__tab-content {
    padding: 0;
  }
}

.opms__loading,
.opms__error,
.opms__empty {
  padding: 3rem;
  text-align: center;
  color: #6b7280;
  font-size: 1.05rem;
}

.opms__error {
  color: #b91c1c;
}

/* =============================================================================
   Skeleton de chargement (shimmer). CSS auto-contenu, prefixe .opms-sk, geometrie
   calee sur le vrai rendu (banniere OperationHeaderBanner + onglets + contenu).
   ============================================================================= */
@keyframes opms-sk-shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.opms-skeleton {
  pointer-events: none;
}

.opms-sk {
  display: block;
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: opms-sk-shimmer 1.4s ease-in-out infinite;
  border-radius: 6px;
}

/* Banniere : meme geometrie que OperationHeaderBanner (padding 2rem 4rem, marge basse 2rem,
   fond sombre) pour une hauteur identique au vrai header. */
.opms-sk-banner {
  padding: 2rem 4rem;
  margin-bottom: 2rem;
  background: #1f2937;
}

/* Sur fond sombre, les blocs shimmer sont clairs. */
.opms-sk-banner .opms-sk {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.14) 25%, rgba(255, 255, 255, 0.28) 50%, rgba(255, 255, 255, 0.14) 75%);
  background-size: 200% 100%;
}

.opms-sk-back { padding: 1rem 0; }
.opms-sk-back .opms-sk-circle { width: 4.5rem; height: 4.5rem; border-radius: 50%; }

.opms-sk-h1 { height: 4.1rem; display: flex; align-items: center; }
.opms-sk-h1 .opms-sk { width: 45%; height: 2.4rem; }

.opms-sk-h2 { height: 3.1rem; display: flex; align-items: center; }
.opms-sk-h2 .opms-sk { width: 32%; height: 1.8rem; }

.opms-sk-subtitle { height: 1.9rem; margin-bottom: 2rem; display: flex; align-items: center; }
.opms-sk-subtitle .opms-sk { width: 38%; height: 1.4rem; }

.opms-sk-statusline { height: 2rem; display: flex; align-items: center; }
.opms-sk-statusline .opms-sk { width: 15rem; height: 1.8rem; border-radius: 20px; }

/* Barre d'onglets : mime .opms__tab-nav (border-bottom, marge basse 3rem). */
.opms-sk-tabs {
  display: flex;
  gap: 2rem;
  border-bottom: 1px solid #e5e7eb;
  padding: 1rem 0;
  margin-bottom: 3rem;
}
.opms-sk-tab { width: 80px; height: 1.6rem; }

/* Contenu : empilement de blocs (le padding vient de .opms__tab-content). */
.opms-sk-content {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.opms-sk-block { width: 100%; height: 90px; }
.opms-sk-block--lg { height: 220px; }

.opms__placeholder {
  padding: 2.5rem;
  text-align: center;
  color: #6b7280;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  margin: 1rem 0;
}

/* --- Descriptif administratif (OperationFormulaireAdmin) : regles specifiques reprises
   de l'ancien FormulaireAdministratif.css, namespacees .opms. Le layout form-row/grid-3/
   form-group/input-inactif est global. --- */
.opms .date-input {
  width: 100%;
}

.opms .radio-options {
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
}

.opms .radio-options label {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  cursor: pointer;
}

.opms .radio-options input[type='radio'] {
  width: 1.6rem;
  height: 1.6rem;
  margin: 0;
}

.opms .step-container .form-subtitle {
  font-size: 1.2rem;
  color: #6b7280;
  font-style: italic;
  margin-left: 0.5rem;
}

.opms .desc-precision {
  display: block;
  margin: 2rem 0;
}

.opms .view-mode .form-group {
  margin-bottom: 2rem;
}

.opms .view-mode label {
  font-weight: 600;
  display: block;
  margin-bottom: 0.5rem;
  color: #2c3948;
}

/* Autocomplete adresse IGN */
.opms .autocomplete-container {
  position: relative;
}

.opms .autocomplete-list {
  position: absolute;
  z-index: 20;
  top: 100%;
  left: 0;
  right: 0;
  margin: 2px 0 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  max-height: 220px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.opms .autocomplete-list li {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.95rem;
}

.opms .autocomplete-list li:hover {
  background: #f3f4f6;
}

/* --- Onglet Consultation --- */
.opms__attestation {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.opms__attestation--error {
  border-color: #dc3545;
}

.opms__attestation-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  margin-bottom: 0;
}

.opms__attestation-label input[type='checkbox'] {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
}

.opms__attestation-display {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.opms__consultation .definition-besoin-textarea {
  width: 100%;
  min-height: 200px;
  resize: vertical;
  /* Un textarea n'herite pas sa police par defaut : on force font: inherit (taille du texte ET du
     placeholder) + le meme line-height/padding que les autres champs du descriptif. */
  font: inherit;
  line-height: 1.4;
  padding: 1.2rem;
  box-sizing: border-box;
}

/* Padding horizontal de 2rem a l'interieur des sections pliables, SCOPE a l'onglet
   Consultation MS uniquement (les autres SectionPliable de l'app gardent leur 1.5rem).
   Le vertical reste celui par defaut de .section-pliable-content. */
.opms__consultation .section-pliable-content {
  padding: 4rem;
}

/* Besoin en lecture seule (remplace l'ancienne classe legacy .definition-besoin). */
.opms__besoin-readonly {
  min-height: 80px;
  white-space: pre-wrap;
}

.opms__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
  padding: 1rem 0;
}

.opms__actions-error {
  width: 100%;
  margin-bottom: 1rem;
}

/* ===== Onglet Analyse ===== */

.opms__placeholder--inline {
  padding: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
}

.opms__analyse-info {
  margin-top: 1rem;
  padding: 0.8rem 1rem;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  color: #166534;
}

/* Accordeon (atome) */
.opms__accordion {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 1rem;
  background: #fff;
}

.opms__accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  background-color: #595959;
  color: #fffdfc;
  padding: 1rem;
  font-size: 1.5rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.opms__accordion-title {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.opms__accordion-lock {
  flex-shrink: 0;
  opacity: 0.85;
}

.opms__accordion-hint {
  font-size: 1rem;
  font-weight: 400;
  font-style: italic;
  opacity: 0.85;
}


.opms__accordion-chevron {
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.opms__accordion-chevron--open {
  transform: rotate(180deg);
}

.opms__accordion-body {
  padding: 1.2rem;
}

/* Banniere de pré-analyse IA (orange, sans icone) : texte d'avertissement a gauche, action a
   droite. Le composant Banner enveloppe le message dans un <p> (.ui-banner__text) -> on l'etale
   pour que le layout interne occupe toute la largeur. */
.opms__ia-banner .ui-banner__text {
  flex: 1 1;
  width: 100%;
}

.opms__ia-banner-inner {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.5rem;
}

.opms__ia-banner-text {
  flex: 1 1;
}

/* Colonne d'action a droite : bouton, puis dessous l'indicateur (spinner pendant l'analyse,
   « Pré-analyse IA terminée » une fois finie). */
.opms__ia-banner-action {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  text-align: center;
}

.opms__ia-status {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  font-weight: 600;
  color: #c2410c;
}

.opms__ia-status--done {
  color: #166534;
}

/* Circular progress (orange) : indicateur « analyse en cours » sous le bouton. */
@keyframes opms-ia-spin {
  to {
    transform: rotate(360deg);
  }
}

.opms__ia-spinner {
  width: 2.2rem;
  height: 2.2rem;
  border: 3px solid rgba(194, 65, 12, 0.25);
  border-top-color: #c2410c;
  border-radius: 50%;
  animation: opms-ia-spin 0.8s linear infinite;
}

.opms__accordion--locked .opms__accordion-header {
  background-color: #9ca3af;
  cursor: not-allowed;
}

/* Section 1 — Reception des plis */
.opms__reception-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  align-items: flex-start;
  justify-content: space-between;
}

.opms__reception-fields {
  flex: 1 1 420px;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.opms__reception-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: baseline;
}

.opms__reception-label {
  font-weight: 600;
  color: #595959;
  min-width: 320px;
}

.opms__reception-value {
  color: #374151;
}

.opms__reception-link {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: #f97316;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

.opms__reception-link:hover {
  color: #ea580c;
}

.opms__reception-actions {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.4rem;
  min-width: 220px;
}

.opms__reception-hint {
  margin: 0 0 0.4rem;
  font-size: 0.9rem;
  font-style: italic;
  color: #9ca3af;
  text-align: center;
}

/* Cloture : groupe de formulaire + note signataire + erreur inline */
.opms__form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  text-align: left;
}

.opms__signataire-note {
  margin: 0;
  font-size: 0.9rem;
  color: #6b7280;
}

.opms__form-error {
  color: #b91c1c;
  font-size: 0.9rem;
}

/* ===== Grille de comparaison (notation technique / financiere / synthese) ===== */

/* Rappel des criteres (tete de section Analyse technique) : apercu tronque a 2 lignes + "...",
   plein texte revele au survol via le MEME mecanisme que le tooltip du nom d'article
   (.opms__tooltip). Le conteneur porte position:relative + cursor:help comme .opms__article-name. */
.opms__critere-memo {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin: 0 0 1.5rem;
  cursor: help;
  /* Apparence de la banniere grise « info » (.ui-banner--info) : icone "i" a gauche + bloc d'info.
     L'habillage est porte par le CONTENEUR (la zone tronquee -preview reste sans padding -> clip
     net a 2 lignes via max-height). */
  background: rgba(215, 217, 217, 0.2);
  border: 1px solid #d7d9d9;
  padding: 0.85rem 1.25rem;
  border-radius: 8px;
}

/* "i" gris, meme gabarit que .ui-banner__icon du composant Banner. */
.opms__critere-memo-icon {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
}

/* min-width:0 : indispensable pour que le -webkit-line-clamp de l'apercu fonctionne en flex. */
.opms__critere-memo-content {
  flex: 1 1;
  min-width: 0;
}

/* Apercu : exactement 2 lignes + "...". Triple garantie anti-fuite de la 3e ligne :
   -webkit-line-clamp (le "..."), max-height = 2 x line-height (clip dur), overflow hidden.
   Element sans padding + white-space normal (le \\n du texte se reduit a une espace ici). */
.opms__critere-memo-preview {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  max-height: 3em; /* 2 x line-height(1.5) a font-size 1.4rem : coupe net 2 lignes (pas de fuite) */
  color: #595959;
  font-size: 1.4rem;
  line-height: 1.5;
}

/* Override du tooltip de base (.opms__tooltip, width 300px) : large + retours a la ligne
   conserves pour le texte long. Selecteur descendant (0,2,0) -> bat .opms__tooltip (0,1,0). */
.opms__critere-memo .opms__tooltip {
  width: min(760px, 92vw);
  white-space: pre-line;
  font-size: 1.4rem; /* plus gros que l'apercu (1.3rem) : lisible malgre la longueur */
  line-height: 1.6;
}

.opms__critere-memo:hover .opms__tooltip {
  visibility: visible;
  opacity: 1;
}

/* Note "Pour memoire" courte (formule financiere, ponderation synthese) : texte integral,
   meme habillage que l'apercu des criteres techniques. */
.opms__memo-note {
  margin: 0 0 1.5rem;
  color: #374151;
  font-size: 1.3rem;
  line-height: 1.5;
  background: #f9fafb;
  border-left: 3px solid #f97316;
  padding: 0.85rem 1.1rem;
  border-radius: 4px;
}

.opms__presta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  gap: 2rem;
  /* Espace en haut : les badges pilule depassent de -12px et ne doivent pas coller au titre de section. */
  margin-top: 1.75rem;
  margin-bottom: 2rem;
}

.opms__presta-col {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background-color: #fffdfc;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 2rem;
}

.opms__presta-col--disabled {
  opacity: 0.55;
}

/* Badge centre en haut de carte (pilule). Gris par defaut, orange pour gagnant/accepte/signature. */
.opms__presta-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #6b7280;
  color: #fff;
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 2;
  min-width: 192px;
  text-align: center;
  white-space: nowrap;
}

.opms__presta-badge--ok {
  background-color: #f97316;
}

.opms__presta-header {
  margin-bottom: 2rem;
  background-color: rgba(194, 194, 194, 0.5);
  border-radius: 10px;
  padding: 1rem;
  color: #2c3948;
  text-align: center;
}

.opms__presta-header h3 {
  margin: 0 0 0.5rem;
  font-size: 1.8rem;
  color: #2c3948;
}

.opms__presta-header span {
  font-size: 1.4rem;
  color: #6b7280;
}

.opms__field {
  margin-bottom: 2rem;
}

.opms__field > label,
.opms__field-label {
  display: block;
  color: #2c3948;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 0.8rem;
}

.opms__readonly-text {
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background-color: rgba(215, 217, 217, 0.2);
  white-space: pre-wrap;
  word-break: break-word;
  margin-bottom: 1rem;
}

.opms__sep {
  border: none;
  border-top: 1px solid #004681;
  opacity: 0.4;
  margin: 1.5rem 0;
}

.opms__required {
  color: #dc2626;
  margin-left: 2px;
}

.opms__input {
  width: 100%;
  padding: 1.2rem;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  color: #2c3948;
  font-family: inherit;
}

textarea.opms__input {
  /* Hauteur pilotee par AutoGrowTextarea (scrollHeight) : la zone s'adapte au texte,
     sans scroll interne ni poignee de resize. */
  min-height: 4rem;
  resize: none;
  overflow: hidden;
}

.opms__input:disabled {
  background-color: rgba(215, 217, 217, 0.2);
  color: #6b7280;
  cursor: not-allowed;
}

.opms__input--error {
  border-color: #dc3545;
}

.opms__input--inactif {
  background-color: rgba(215, 217, 217, 0.2);
  color: #6b7280;
  padding: 1.2rem;
  border-radius: 10px;
  text-align: center;
}

.opms__note-row {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.opms__note-row > label {
  margin-bottom: 0;
  white-space: nowrap;
}

.opms__note-select {
  flex: 1 1;
}

.opms__note-out-of {
  margin-left: 0.5rem;
  white-space: nowrap;
  font-weight: 600;
}

.opms__presta-footer {
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid #eaeaea;
}

.opms__note-globale {
  margin-top: 2rem;
  text-align: center;
  padding: 1.5rem;
  background-color: rgba(218, 112, 39, 0.15);
  border-radius: 0.8rem;
  color: #2c3948;
  font-weight: bold;
}

.opms__note-globale h4 {
  font-size: 1.6rem;
  margin: 0 0 1rem;
  color: #2c3948;
}

.opms__note-value {
  font-size: 2.4rem;
  font-weight: 700;
  color: #2c3948;
}

/* ===== Synthese (cartes cliquables) ===== */

/* Mise en evidence du mieux-disant (retenu automatique par note globale) */
.opms__presta-col--best {
  border: 3px solid #f97316;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);
}

/* Ligne de notes ponderees : grille 40/60 (V1) */
.opms__synthese-row {
  display: grid;
  grid-template-columns: 40% 60%;
  gap: 2rem;
  margin-bottom: 0.5rem;
}

.opms__synthese-cell {
  font-weight: 600;
}

/* Pilule de ponderation grise (55% / 45%) */
.opms__ponderation-badge {
  display: inline-block;
  padding: 0.2rem 0.6rem;
  border-radius: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
  margin-left: 0.5rem;
  background-color: rgba(215, 217, 217, 0.4);
  color: #595959;
}

.opms__note-detail {
  font-size: 0.95rem;
  color: #6b7280;
  margin-left: 0.5rem;
}

.opms__classement {
  margin-top: 0.8rem;
  font-size: 1.2rem;
  font-weight: 600;
  color: #f97316;
}

/* ===== Grille financiere (DPGF) ===== */

.opms__articles-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
}

.opms__articles-table th,
.opms__articles-table td {
  padding: 0.8rem;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
}

.opms__articles-table th {
  background-color: #d7d9d940;
  font-weight: 600;
  color: #2c3948;
}

.opms__articles-table td:last-child {
  text-align: right;
}

/* En-tete "Prix HT" aligne a droite, comme la colonne prix. */
.opms__articles-table th:last-child {
  text-align: right;
}

/* Specificite (td.classe) pour battre \`.opms__articles-table td:last-child\` (align droite
   de la colonne prix) : le titre de groupe est un td colSpan=2, donc aussi last-child. */
.opms__articles-table td.opms__articles-section {
  background-color: #d7d9d940;
  color: #2c3948;
  text-align: left;
  font-weight: 700;
  font-size: 1.3rem;
}

.opms__article-numero {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.opms__article-code {
  font-weight: 600;
}

/* Nom de l'article : debut affiche, tronque a "…" ; nom complet en tooltip au survol. */
.opms__article-name {
  position: relative;
  color: #374151;
  cursor: help;
}

.opms__tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 5px;
  width: 300px;
  background-color: #595959;
  color: #fff;
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  font-weight: 400;
  text-align: left;
  white-space: normal;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s, visibility 0.2s;
  pointer-events: none;
  z-index: 10;
}

.opms__article-name:hover .opms__tooltip {
  visibility: visible;
  opacity: 1;
}

.opms__tooltip::before {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 10px;
  border-width: 6px;
  border-style: solid;
  border-color: transparent transparent #595959 transparent;
}

.opms__total-row {
  font-weight: 700;
  font-size: 1.6rem;
  text-align: right;
  padding: 1rem;
  background-color: rgba(215, 217, 217, 0.2);
  border-radius: 4px;
  margin-bottom: 2rem;
}

/* ===== Onglet Marché / Notifications et signatures ===== */

/* Les sections du Marché sont enveloppées dans OperationAnalyseAccordion :
   bordure, radius et padding du corps sont fournis par .opms__accordion / .opms__accordion-body.
   .opms__marche-body reste un conteneur transparent (passthrough). */
.opms__marche-body {
  padding: 0;
  /* Les marges verticales de freres adjacents FUSIONNENT dans un bloc : \`.opms__marche-preview\`
     (margin-bottom 1.5rem) et \`.opms__marche-sign-bottom\` (margin-top 1.6rem) ne produisaient que
     1.6rem au lieu de 3.1rem. Un contexte flex supprime cette fusion. Meme correction que la case BC
     (\`.bc-notif .section-content\`). */
  display: flex;
  flex-direction: column;
}

/* Section « Préparation du MS » : recap read-only en grille responsive (label gris + valeur). */
.opms__recap-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.2rem 2rem;
}

.opms__recap-field {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.opms__recap-label {
  font-size: 1.2rem;
  color: #6b7280;
}

.opms__recap-value {
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c3948;
  word-break: break-word;
}

.opms__recap-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
}

/* Ancre de scroll du bouton « Prévisualiser le marché ». */
.opms__marche-anchor {
  scroll-margin-top: 1rem;
}

/* Section « Information aux candidats » : tableau retenu / non-retenus. */
.opms__candidats {
  margin-bottom: 1.5rem;
}

.opms__candidats-row {
  display: grid;
  grid-template-columns: 1.4fr 1.6fr 1.4fr 1.6fr;
  gap: 1rem;
  align-items: center;
  padding: 0.8rem 0;
  border-bottom: 1px solid #eaeaea;
  font-size: 1.3rem;
  color: #2c3948;
}

.opms__candidats-head {
  font-size: 1.2rem;
  font-weight: 600;
  color: #6b7280;
  border-bottom: 2px solid #d7d9d9;
}

.opms__candidats-nom {
  font-weight: 600;
}

.opms__candidats-mail {
  word-break: break-all;
}

.opms__candidats-link {
  background: none;
  border: none;
  padding: 0;
  color: #f97316;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

.opms__candidats-action {
  display: inline-flex;
  flex-direction: column;
  gap: 0.3rem;
  align-items: flex-start;
}

.opms__candidats-error {
  color: #b91c1c;
  font-size: 1.1rem;
}

.opms__marche-signature > h4,
.opms__marche-signature > h5 {
  margin-top: 0;
  color: #2c3948;
}

.opms__marche-preview {
  margin-bottom: 1.5rem;
}

.opms__marche-pdf {
  margin-top: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f5f5f5;
}

.opms__marche-iframe {
  width: 100%;
  height: 600px;
  border: none;
}

.opms__marche-pdf-empty {
  padding: 2rem;
  text-align: center;
  color: #666;
}

/* Preview PDF a 3/4 de la largeur : l'utilisateur peut scroller la page facilement autour. */
.opms__marche-pdf--narrow {
  width: 75%;
}

/* Bloc « Rappel des documents associés » (Contrat + 2 CCTP en cartes + carte-bouton profil). */
.opms__marche-docs {
  margin-bottom: 1.5rem;
}

/* Cartes documents + carte-bouton profil sur la meme ligne : grille a colonnes egales.
   Les conteneurs internes de DocumentsList sont aplatis (display: contents) pour que ses cartes
   ET la carte-bouton deviennent des items directs de CETTE grille (colonnes uniformes). */
.opms__marche-docs-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  align-items: stretch;
  gap: 1rem;
}

.opms__marche-docs-row .documents-list,
.opms__marche-docs-row .documents-grid {
  display: contents;
}

/* Libelle des cartes-documents : retour a la ligne (2 lignes) plutot que troncature "..." . */
.opms__marche-docs .document-card-type {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}

/* Carte-bouton « Voir les autres documents... » : reutilise l'habillage .document-card. */
.opms__marche-doc-more {
  cursor: pointer;
  text-align: left;
}

.opms__marche-docs > h5 {
  margin: 1.5rem 0 0.8rem;
  color: #2c3948;
}

/* Signataire en bas de la section signature + bouton « Signer et notifier ». */
.opms__marche-signataire {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-top: 1rem;
}

.opms__marche-signataire-line {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
  margin: 0;
  font-size: 1.3rem;
  color: #2c3948;
}

.opms__marche-signataire-input {
  min-width: 220px;
}

/* Bouton « Signer et notifier » : aligne a droite, largeur naturelle (pas pleine largeur). */
.opms__marche-signataire-action {
  display: flex;
  justify-content: flex-end;
}

/* Le composant Button a \`align-self: stretch\` global : dans la barre du bas (a cote du PrintButton
   plus haut) il s'etire en hauteur, alors que dans le bloc signataire il garde sa hauteur naturelle.
   On force \`center\` partout -> meme taille du bouton « Signer et notifier » aux 3 emplacements. */
.opms__marche-sign-top .button,
.opms__marche-sign-bottom .button,
.opms__marche-signataire-action .button,
.opms__actions .button {
  align-self: center;
}

.opms__marche-sign-direct,
.opms__marche-request {
  margin-top: 1.5rem;
}

.opms__marche-request {
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.opms__marche-request-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.opms__marche-request-history {
  margin-top: 2rem;
  padding: 1.5rem;
  background-color: #d4edda;
  border-radius: 12px;
  border-left: 6px solid #28a745;
}

.opms__marche-request-history > h5 {
  color: #155724;
  margin: 0 0 1.25rem;
}

.opms__marche-request-entry {
  padding: 1rem 1.25rem;
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 8px;
  color: #155724;
  margin-bottom: 1rem;
}

.opms__marche-request-label {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.opms__marche-request-date {
  font-size: 0.95rem;
  opacity: 0.85;
}

.opms__marche-complete {
  text-align: center;
}

.opms__marche-success h4 {
  color: #2c3948;
  margin: 1rem 0;
}

.opms__marche-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;
}

.opms__marche-notify {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #ddd;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

/* Modale d'aperçu du mail de notification */
.opms__marche-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.opms__marche-modal {
  position: relative;
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 80vw;
  max-height: 90vh;
  overflow-y: auto;
}

.opms__marche-modal-bar {
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.opms__marche-notified {
  color: #10b981;
  font-weight: 600;
  white-space: nowrap;
}

/* Titre / date d'envoi de la popup « Voir le message » + actions (PDF / Fermer). */
.opms__marche-modal-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c3948;
}

.opms__marche-modal-actions {
  display: flex;
  gap: 0.6rem;
}

/* « Signer et notifier » duplique en haut de section : aligne a droite. */
.opms__marche-sign-top {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}

/* Pendant BAS de \`.opms__marche-sign-top\` : meme alignement, mais la marge passe EN HAUT — le bouton
   suit desormais la previsualisation au lieu de la preceder.
   Espacement calque sur la reference BC (\`.bc-notif__actions\` : gap 1rem, margin-top 1.6rem) pour que
   le meme bouton respire pareil d'un module a l'autre. Sert aux DEUX cases MS (acheteur et
   prestataire), qui partagent cette feuille. */
.opms__marche-sign-bottom {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.6rem;
}

/* --- Analyse IA en cours : skeleton (shimmer) sur les champs commentaire / note ---
   Reutilise la brique .opms-sk (shimmer, definie plus haut). Geometrie calee sur le vrai
   champ pour eviter le saut de mise en page a l'arrivee des donnees. */
.opms-sk-line {
  height: 1.2rem;
  width: 100%;
}

.opms-sk-line--short {
  width: 60%;
}

/* Commentaire : meme min-height que textarea.opms__input (4rem), 3 lignes shimmer. */
.opms-sk-comment {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  min-height: 4rem;
  padding: 0.4rem 0;
}

/* Note : occupe la place du select (flex:1 via .opms__note-select), hauteur du champ. */
.opms-sk-note {
  height: 4.2rem;
}

/* Note technique globale : meme gabarit que .opms__note-value (2.4rem), centre. */
.opms-sk-noteglobale {
  width: 6rem;
  height: 2.4rem;
  margin: 0 auto;
}

/* Synthese en attente de l'analyse IA. */
.opms-sk-synthese {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding: 2rem 1rem;
}

/* --- Refonte Descriptif administratif (onglet Consultation) : sous-sections Acheteur /
   Operation / Particularites + utilitaire pleine largeur dans la grille. --- */
.opms__descriptif-admin .opms__sous-section {
  margin-bottom: 2.4rem;
}
.opms__descriptif-admin .opms__sous-section:last-child {
  margin-bottom: 0;
}
.opms__sous-section-titre {
  font-size: 2rem;
  font-weight: 700;
  color: #000;
  margin: 0 0 1.2rem;
  padding-bottom: 0.6rem;
}
.opms__descriptif-admin .opms__span-full {
  grid-column: 1 / -1;
}

/* Grille 12 colonnes des sous-blocs (fidele au PDF : lignes de 3 / 4 / 2 champs via les spans). */
.opms__descriptif-admin .opms__admin-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 1.2rem 2rem;
  align-items: start;
}
@media (max-width: 900px) {
  .opms__descriptif-admin .opms__admin-grid > * {
    grid-column: 1 / -1 !important;
  }
}

/* Champs editables a la MEME taille que les read-only (.input-inactif) : meme box-model.
   La bordure transparente du read-only egalise sa hauteur avec la bordure 1px de l'input. */
.opms__descriptif-admin .form-group input,
.opms__descriptif-admin .form-group textarea,
.opms__descriptif-admin .form-group select,
.opms__descriptif-admin .form-group .input-inactif {
  width: 100%;
  box-sizing: border-box;
  padding: 1.2rem;
  border-radius: 10px;
  font: inherit;
  line-height: 1.4;
}
/* Champs sur une ligne (input, select, read-only) : meme hauteur mini -> le select colle aux inputs. */
.opms__descriptif-admin .form-group input,
.opms__descriptif-admin .form-group select,
.opms__descriptif-admin .form-group .input-inactif {
  min-height: 4.6rem;
}
.opms__descriptif-admin .form-group input,
.opms__descriptif-admin .form-group textarea,
.opms__descriptif-admin .form-group select {
  border: 1px solid #e5e7eb;
  color: #2c3948;
  background: #fff;
}
.opms__descriptif-admin .form-group .input-inactif {
  border: 1px solid transparent;
}
/* Le champ adresse est etroit (span 3) : la liste d'autocomplete s'elargit au-dela de la cellule
   pour afficher les adresses completes sans troncature. */
.opms__descriptif-admin .autocomplete-list {
  right: auto;
  min-width: 36rem;
  max-width: 60rem;
  max-height: 32rem;
}
.opms__descriptif-admin .autocomplete-list li {
  font-size: 1.3rem;
  padding: 1rem 1.2rem;
  white-space: normal;
  line-height: 1.35;
}

/* Chevron custom du select (le fond blanc masque la fleche native). */
.opms__descriptif-admin .form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1.2rem center;
  padding-right: 3.6rem;
  cursor: pointer;
}

/* Modale des criteres = AccueilModal contrainte : largeur 72rem, hauteur au contenu (max 85vh).
   Elle apporte deja la croix header, le clic-overlay et Escape. */
.accueil-modal.opms__critere-modal {
  width: min(72rem, calc(100vw - 2rem));
  height: auto;
  max-height: 85vh;
}
.opms__critere-modal .accueil-modal-body {
  padding: 2rem 2.4rem;
  /* Scrollbar TOUJOURS visible (sinon overlay auto-hide sur Mac -> on ne voit pas le contenu en bas). */
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: #b0b0b0 #f1f1f1;
}
.opms__critere-modal .accueil-modal-body::-webkit-scrollbar {
  width: 10px;
}
.opms__critere-modal .accueil-modal-body::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border-radius: 5px;
}
.opms__critere-modal .accueil-modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* "Lire la suite" : lien inline dans un champ read-only (ouvre la modale ValidationPopUp des criteres). */
.opms__lire-la-suite {
  background: none;
  border: none;
  padding: 0;
  color: #f97316;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
}

/* Rappel criteres/ponderations (bas du Descriptif procedural) : 4 champs read-only span-3 sur UNE
   ligne (4-across), de MEME taille. Le titre le plus long ne tient pas sur une ligne a taille normale
   dans un span-3 -> police reduite (1.05rem) + nowrap (pas d'ellipsis). Boites a hauteur fixe = 2
   lignes ; le 1er champ est tronque cote donnee (critereTechniqueApercu) pour tenir en ~2 lignes en
   gardant "lire la suite" inline visible. */
/* Titres a taille classique : le 1er (le plus long) peut passer sur 2 lignes. On reserve 2 lignes de
   hauteur pour les 4 labels (min-height + line-height fixe) -> les 4 boites restent alignees meme quand
   un seul titre wrap. */
.opms__rappel-champ > label {
  display: block;
  line-height: 1.3;
  min-height: 2.6em;
}
.opms__descriptif-admin .opms__rappel-champ .input-inactif {
  height: 6.6rem;
  min-height: 6.6rem;
  overflow: hidden;
}

/* "(GMT Paris)" affiche DANS le champ date-heure : le wrapper porte la bordure/le box-model,
   l'input est sans bordure a l'interieur, le suffixe est colle a droite dans la meme boite. */
.opms__datetime-gmt {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  padding-right: 1.2rem;
  min-height: 4.6rem;
}
/* Input a l'interieur du wrapper : sans bordure ni hauteur propre (le wrapper porte le box-model).
   Le 2e selecteur bat la regle harmonisee \`.opms__descriptif-admin .form-group input\` (contexte procedural). */
.opms__datetime-gmt input,
.opms__descriptif-admin .form-group .opms__datetime-gmt input {
  flex: 1 1;
  min-width: 0;
  border: none;
  min-height: 0;
  background: transparent;
  font: inherit;
  padding: 1.2rem;
  color: #2c3948;
  outline: none;
}
.opms__datetime-gmt-suffix {
  color: #6b7280;
  font-size: 1.3rem;
  white-space: nowrap;
}
/* Etat erreur (champ date obligatoire vide au lancement) : bordure rouge, meme code que les inputs .error. */
.opms__datetime-gmt.error {
  border-color: #dc2626;
}

/* Compteur de caracteres (guard "une phrase" = 255) sous les champs texte descriptifs des blocs
   Acheteur & Operation. Meme rendu que le compteur du profil (.char-count). */
.opms__char-count {
  display: block;
  text-align: right;
  font-size: 1.1rem;
  color: #6b7280;
  margin-top: 0.3rem;
}

/* "Documents liés à la consultation" : DocumentsList (CCTP cliquables) + champ des pieces specifiques
   qui prend l'espace restant, fondus dans un seul bloc sous un label unique (pas deux colonnes separees). */
/* Le champ des pieces specifiques est le contenu du trailingCard de DocumentsList (qui gere la sizing
   "2 places" via .documents-grid-trailing). Ici on ne fait que le VISUEL : fond gris read-only, bordure
   de carte, meme hauteur mini. Son contenu scrolle dans un inner absolu -> ne dicte pas la hauteur. */
.opms__docs-consultation-champ {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 88px;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  background: rgba(215, 217, 217, 0.2);
  overflow: hidden;
}
/* Label du champ (design system : header section #595959) au-dessus du contenu reel. */
.opms__docs-consultation-champ-label {
  flex-shrink: 0;
  padding: 1rem 1.25rem 0.4rem;
  color: #595959;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.3;
}
/* Contenu reel : prend la place restante sous le label et scrolle (ne dicte pas la hauteur de la carte). */
.opms__docs-consultation-champ-inner {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  padding: 0 1.25rem 1.125rem;
  color: #374151;
  line-height: 1.4;
  white-space: pre-wrap;
}

/* Section Prolongation : aligne le padding du corps de l'accordeon (1.2rem par defaut) sur celui des
   autres sections de l'onglet Consultation (4rem), sans toucher le composant partage avec l'Analyse. */
.opms__prolongation-section .opms__accordion-body {
  padding: 4rem;
}

/* Onglet "Notifications et signatures" : ses sections sont passees sur SectionPliable (comme les
   onglets BC), le padding vient donc de \`.section-pliable-content\` — 1.5rem par defaut. On l'aligne
   sur la reference BC, qui fait 4rem via \`.consultation-bc .section-pliable-content\`.
   La chaine d'espacement du bouton de telechargement devient alors identique des deux cotes :
     padding de section 4rem  ·  marge sous l'apercu 1.5rem  ·  marge au-dessus du bouton 1.6rem
   Scope a \`.opms__marche\` — racine des DEUX cases MS (acheteur et prestataire). */
.opms__marche .section-pliable-content {
  padding: 4rem;
}

/* Section "Prolongation de délai" (onglet Consultation). */
.opms__prolongation {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-top: 1.6rem;
}
.opms__prolongation .form-group {
  max-width: 48rem;
}
.opms__prolongation-historique h4 {
  margin: 0 0 0.8rem;
  color: #595959;
  font-size: 1.6rem;
}
.opms__prolongation-historique ul {
  margin: 0;
  padding-left: 1.8rem;
  line-height: 1.6;
  color: #374151;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviOperationMSV2/SuiviOperationMSV2.css"],"names":[],"mappings":"AAAA;;6FAE6F;;AAE7F;;;iDAGiD;AACjD;EACE,6FAA6F;EAC7F,yBAAyB;AAC3B;;AAEA;+FAC+F;AAC/F;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;;;EAGE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;kFAGkF;AAClF;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yEAAyE;EACzE,0BAA0B;EAC1B,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;4DAC4D;AAC5D;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,+HAA+H;EAC/H,0BAA0B;AAC5B;;AAEA,gBAAgB,eAAe,EAAE;AACjC,gCAAgC,aAAa,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAEnF,cAAc,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAClE,uBAAuB,UAAU,EAAE,cAAc,EAAE;;AAEnD,cAAc,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAClE,uBAAuB,UAAU,EAAE,cAAc,EAAE;;AAEnD,oBAAoB,cAAc,EAAE,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAC7F,6BAA6B,UAAU,EAAE,cAAc,EAAE;;AAEzD,sBAAsB,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACxE,+BAA+B,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAElF,6EAA6E;AAC7E;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;AACA,eAAe,WAAW,EAAE,cAAc,EAAE;;AAE5C,4EAA4E;AAC5E;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA,iBAAiB,WAAW,EAAE,YAAY,EAAE;AAC5C,qBAAqB,aAAa,EAAE;;AAEpC;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;6CAE6C;AAC7C;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,OAAO;EACP,QAAQ;EACR,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB;sFACoF;EACpF,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;oEAEoE;AACpE;EACE,aAAa;AACf;;AAEA,oFAAoF;AACpF;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,+BAA+B;;AAE/B;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;;AAGA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;wDAEwD;AACxD;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;iDACiD;AACjD;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iFAAiF;AACjF;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,mFAAmF;;AAEnF;;oGAEoG;AACpG;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ;;sCAEoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,qEAAqE;AACrE;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,+FAA+F;AAC/F;EACE,SAAO;EACP,YAAY;AACd;;AAEA;;2FAE2F;AAC3F;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe,EAAE,gFAAgF;EACjG,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;8FAC8F;AAC9F;EACE,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB,EAAE,iEAAiE;EACpF,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;yDACyD;AACzD;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,wGAAwG;EACxG,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,oGAAoG;AACpG;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;gDAC8C;EAC9C,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6CAA6C;;AAE7C,2EAA2E;AAC3E;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yCAAyC;;AAEzC;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,8DAA8D;AAC9D;EACE,iBAAiB;AACnB;;AAEA;yFACyF;AACzF;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wFAAwF;AACxF;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,yCAAyC;EACzC,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,4DAA4D;;AAE5D;;qEAEqE;AACrE;EACE,UAAU;EACV;;;sCAGoC;EACpC,aAAa;EACb,sBAAsB;AACxB;;AAEA,gGAAgG;AAChG;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,uBAAuB;AACzB;;AAEA,0EAA0E;AAC1E;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA,6FAA6F;AAC7F;EACE,UAAU;AACZ;;AAEA,+FAA+F;AAC/F;EACE,qBAAqB;AACvB;;AAEA;;0FAE0F;AAC1F;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;EACpB,SAAS;AACX;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,8FAA8F;AAC9F;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,0FAA0F;AAC1F;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6FAA6F;AAC7F;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;kGAEkG;AAClG;;;;EAIE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mFAAmF;AACnF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;;+CAI+C;AAC/C;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;AACpB;;AAEA;;uEAEuE;AACvE;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,qFAAqF;AACrF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wFAAwF;AACxF;EACE,cAAc;AAChB;;AAEA,kFAAkF;AAClF;EACE,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;+EAC+E;AAC/E;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;;AAEA,kGAAkG;AAClG;EACE,aAAa;EACb,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;4FAC4F;AAC5F;;;;EAIE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;AACA,uGAAuG;AACvG;;;EAGE,kBAAkB;AACpB;AACA;;;EAGE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;0DAC0D;AAC1D;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sEAAsE;AACtE;EAGE,gBAAgB;EAChB,yDAAqR;EACrR,4BAA4B;EAC5B,wCAAwC;EACxC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;kEACkE;AAClE;EACE,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,sGAAsG;EACtG,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA,0GAA0G;AAC1G;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;4CAI4C;AAC5C;;wBAEwB;AACxB;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;8FAC8F;AAC9F;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;+GAC+G;AAC/G;;EAEE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA,6GAA6G;AAC7G;EACE,qBAAqB;AACvB;;AAEA;8EAC8E;AAC9E;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;4GAC4G;AAC5G;;sGAEsG;AACtG;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;AAClB;AACA,uFAAuF;AACvF;EACE,cAAc;EACd,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA,2GAA2G;AAC3G;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;uGACuG;AACvG;EACE,aAAa;AACf;;AAEA;;;;;kFAKkF;AAClF;EACE,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/* CSS UNIQUE de la case acheteur Operation MS (V2). Tout le style propre a la case vit ici,\n   sous le namespace .opms. Pas de CSS par composant, pas de reutilisation des feuilles legacy\n   (Consultation.css / Analyse.css / Marche.css...). Le fichier grandit au fil des onglets. */\n\n/* Layout du shell (remplace les anciennes classes legacy suivi-commande / suivi-de-commande-content\n   / tab-content qui couplaient la case au CSS legacy). Auto-suffisant : seul .opms est requis.\n   Padding aligne sur la case BC (.opbc__content / .opbc__tab-content) : top a 0 pour que la barre\n   d'onglets soit a la meme hauteur que le BDC. */\n.opms__content {\n  /* Inset 6rem comme les autres pages ; le banner (hors de ce wrapper) reste pleine largeur. */\n  padding: 0 6rem 2rem 6rem;\n}\n\n/* Padding vertical + un peu d'air a gauche/droite du contenu des onglets (l'horizontal s'ajoute\n   aux 2rem de .opms__content sans toucher l'alignement de la barre d'onglets ni la case BC). */\n.opms__tab-content {\n  padding: 2rem 1.5rem;\n  min-height: 500px;\n}\n\n@media print {\n  .opms__tab-content {\n    padding: 0;\n  }\n}\n\n.opms__loading,\n.opms__error,\n.opms__empty {\n  padding: 3rem;\n  text-align: center;\n  color: #6b7280;\n  font-size: 1.05rem;\n}\n\n.opms__error {\n  color: #b91c1c;\n}\n\n/* =============================================================================\n   Skeleton de chargement (shimmer). CSS auto-contenu, prefixe .opms-sk, geometrie\n   calee sur le vrai rendu (banniere OperationHeaderBanner + onglets + contenu).\n   ============================================================================= */\n@keyframes opms-sk-shimmer {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n\n.opms-skeleton {\n  pointer-events: none;\n}\n\n.opms-sk {\n  display: block;\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\n  background-size: 200% 100%;\n  animation: opms-sk-shimmer 1.4s ease-in-out infinite;\n  border-radius: 6px;\n}\n\n/* Banniere : meme geometrie que OperationHeaderBanner (padding 2rem 4rem, marge basse 2rem,\n   fond sombre) pour une hauteur identique au vrai header. */\n.opms-sk-banner {\n  padding: 2rem 4rem;\n  margin-bottom: 2rem;\n  background: #1f2937;\n}\n\n/* Sur fond sombre, les blocs shimmer sont clairs. */\n.opms-sk-banner .opms-sk {\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.14) 25%, rgba(255, 255, 255, 0.28) 50%, rgba(255, 255, 255, 0.14) 75%);\n  background-size: 200% 100%;\n}\n\n.opms-sk-back { padding: 1rem 0; }\n.opms-sk-back .opms-sk-circle { width: 4.5rem; height: 4.5rem; border-radius: 50%; }\n\n.opms-sk-h1 { height: 4.1rem; display: flex; align-items: center; }\n.opms-sk-h1 .opms-sk { width: 45%; height: 2.4rem; }\n\n.opms-sk-h2 { height: 3.1rem; display: flex; align-items: center; }\n.opms-sk-h2 .opms-sk { width: 32%; height: 1.8rem; }\n\n.opms-sk-subtitle { height: 1.9rem; margin-bottom: 2rem; display: flex; align-items: center; }\n.opms-sk-subtitle .opms-sk { width: 38%; height: 1.4rem; }\n\n.opms-sk-statusline { height: 2rem; display: flex; align-items: center; }\n.opms-sk-statusline .opms-sk { width: 15rem; height: 1.8rem; border-radius: 20px; }\n\n/* Barre d'onglets : mime .opms__tab-nav (border-bottom, marge basse 3rem). */\n.opms-sk-tabs {\n  display: flex;\n  gap: 2rem;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 1rem 0;\n  margin-bottom: 3rem;\n}\n.opms-sk-tab { width: 80px; height: 1.6rem; }\n\n/* Contenu : empilement de blocs (le padding vient de .opms__tab-content). */\n.opms-sk-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n}\n.opms-sk-block { width: 100%; height: 90px; }\n.opms-sk-block--lg { height: 220px; }\n\n.opms__placeholder {\n  padding: 2.5rem;\n  text-align: center;\n  color: #6b7280;\n  background: #f9fafb;\n  border: 1px dashed #e5e7eb;\n  border-radius: 8px;\n  margin: 1rem 0;\n}\n\n/* --- Descriptif administratif (OperationFormulaireAdmin) : regles specifiques reprises\n   de l'ancien FormulaireAdministratif.css, namespacees .opms. Le layout form-row/grid-3/\n   form-group/input-inactif est global. --- */\n.opms .date-input {\n  width: 100%;\n}\n\n.opms .radio-options {\n  display: flex;\n  gap: 2rem;\n  margin-top: 1rem;\n}\n\n.opms .radio-options label {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  cursor: pointer;\n}\n\n.opms .radio-options input[type='radio'] {\n  width: 1.6rem;\n  height: 1.6rem;\n  margin: 0;\n}\n\n.opms .step-container .form-subtitle {\n  font-size: 1.2rem;\n  color: #6b7280;\n  font-style: italic;\n  margin-left: 0.5rem;\n}\n\n.opms .desc-precision {\n  display: block;\n  margin: 2rem 0;\n}\n\n.opms .view-mode .form-group {\n  margin-bottom: 2rem;\n}\n\n.opms .view-mode label {\n  font-weight: 600;\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #2c3948;\n}\n\n/* Autocomplete adresse IGN */\n.opms .autocomplete-container {\n  position: relative;\n}\n\n.opms .autocomplete-list {\n  position: absolute;\n  z-index: 20;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin: 2px 0 0;\n  padding: 0;\n  list-style: none;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  max-height: 220px;\n  overflow-y: auto;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.opms .autocomplete-list li {\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 0.95rem;\n}\n\n.opms .autocomplete-list li:hover {\n  background: #f3f4f6;\n}\n\n/* --- Onglet Consultation --- */\n.opms__attestation {\n  margin-bottom: 20px;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n}\n\n.opms__attestation--error {\n  border-color: #dc3545;\n}\n\n.opms__attestation-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  margin-bottom: 0;\n}\n\n.opms__attestation-label input[type='checkbox'] {\n  width: 14px;\n  height: 14px;\n  flex: 0 0 auto;\n}\n\n.opms__attestation-display {\n  margin-bottom: 20px;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n}\n\n.opms__consultation .definition-besoin-textarea {\n  width: 100%;\n  min-height: 200px;\n  resize: vertical;\n  /* Un textarea n'herite pas sa police par defaut : on force font: inherit (taille du texte ET du\n     placeholder) + le meme line-height/padding que les autres champs du descriptif. */\n  font: inherit;\n  line-height: 1.4;\n  padding: 1.2rem;\n  box-sizing: border-box;\n}\n\n/* Padding horizontal de 2rem a l'interieur des sections pliables, SCOPE a l'onglet\n   Consultation MS uniquement (les autres SectionPliable de l'app gardent leur 1.5rem).\n   Le vertical reste celui par defaut de .section-pliable-content. */\n.opms__consultation .section-pliable-content {\n  padding: 4rem;\n}\n\n/* Besoin en lecture seule (remplace l'ancienne classe legacy .definition-besoin). */\n.opms__besoin-readonly {\n  min-height: 80px;\n  white-space: pre-wrap;\n}\n\n.opms__actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  padding: 1rem 0;\n}\n\n.opms__actions-error {\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n/* ===== Onglet Analyse ===== */\n\n.opms__placeholder--inline {\n  padding: 1.5rem;\n  border: 1px dashed #d1d5db;\n  border-radius: 8px;\n}\n\n.opms__analyse-info {\n  margin-top: 1rem;\n  padding: 0.8rem 1rem;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 8px;\n  color: #166534;\n}\n\n/* Accordeon (atome) */\n.opms__accordion {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 1rem;\n  background: #fff;\n}\n\n.opms__accordion-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  background-color: #595959;\n  color: #fffdfc;\n  padding: 1rem;\n  font-size: 1.5rem;\n  cursor: pointer;\n  user-select: none;\n}\n\n.opms__accordion-title {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.opms__accordion-lock {\n  flex-shrink: 0;\n  opacity: 0.85;\n}\n\n.opms__accordion-hint {\n  font-size: 1rem;\n  font-weight: 400;\n  font-style: italic;\n  opacity: 0.85;\n}\n\n\n.opms__accordion-chevron {\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n}\n\n.opms__accordion-chevron--open {\n  transform: rotate(180deg);\n}\n\n.opms__accordion-body {\n  padding: 1.2rem;\n}\n\n/* Banniere de pré-analyse IA (orange, sans icone) : texte d'avertissement a gauche, action a\n   droite. Le composant Banner enveloppe le message dans un <p> (.ui-banner__text) -> on l'etale\n   pour que le layout interne occupe toute la largeur. */\n.opms__ia-banner .ui-banner__text {\n  flex: 1;\n  width: 100%;\n}\n\n.opms__ia-banner-inner {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1.5rem;\n}\n\n.opms__ia-banner-text {\n  flex: 1;\n}\n\n/* Colonne d'action a droite : bouton, puis dessous l'indicateur (spinner pendant l'analyse,\n   « Pré-analyse IA terminée » une fois finie). */\n.opms__ia-banner-action {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.6rem;\n  text-align: center;\n}\n\n.opms__ia-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #c2410c;\n}\n\n.opms__ia-status--done {\n  color: #166534;\n}\n\n/* Circular progress (orange) : indicateur « analyse en cours » sous le bouton. */\n@keyframes opms-ia-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.opms__ia-spinner {\n  width: 2.2rem;\n  height: 2.2rem;\n  border: 3px solid rgba(194, 65, 12, 0.25);\n  border-top-color: #c2410c;\n  border-radius: 50%;\n  animation: opms-ia-spin 0.8s linear infinite;\n}\n\n.opms__accordion--locked .opms__accordion-header {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Section 1 — Reception des plis */\n.opms__reception-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.opms__reception-fields {\n  flex: 1 1 420px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.opms__reception-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: baseline;\n}\n\n.opms__reception-label {\n  font-weight: 600;\n  color: #595959;\n  min-width: 320px;\n}\n\n.opms__reception-value {\n  color: #374151;\n}\n\n.opms__reception-link {\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  color: #f97316;\n  font-weight: 600;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.opms__reception-link:hover {\n  color: #ea580c;\n}\n\n.opms__reception-actions {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.4rem;\n  min-width: 220px;\n}\n\n.opms__reception-hint {\n  margin: 0 0 0.4rem;\n  font-size: 0.9rem;\n  font-style: italic;\n  color: #9ca3af;\n  text-align: center;\n}\n\n/* Cloture : groupe de formulaire + note signataire + erreur inline */\n.opms__form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  text-align: left;\n}\n\n.opms__signataire-note {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #6b7280;\n}\n\n.opms__form-error {\n  color: #b91c1c;\n  font-size: 0.9rem;\n}\n\n/* ===== Grille de comparaison (notation technique / financiere / synthese) ===== */\n\n/* Rappel des criteres (tete de section Analyse technique) : apercu tronque a 2 lignes + \"...\",\n   plein texte revele au survol via le MEME mecanisme que le tooltip du nom d'article\n   (.opms__tooltip). Le conteneur porte position:relative + cursor:help comme .opms__article-name. */\n.opms__critere-memo {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin: 0 0 1.5rem;\n  cursor: help;\n  /* Apparence de la banniere grise « info » (.ui-banner--info) : icone \"i\" a gauche + bloc d'info.\n     L'habillage est porte par le CONTENEUR (la zone tronquee -preview reste sans padding -> clip\n     net a 2 lignes via max-height). */\n  background: rgba(215, 217, 217, 0.2);\n  border: 1px solid #d7d9d9;\n  padding: 0.85rem 1.25rem;\n  border-radius: 8px;\n}\n\n/* \"i\" gris, meme gabarit que .ui-banner__icon du composant Banner. */\n.opms__critere-memo-icon {\n  flex-shrink: 0;\n  width: 2rem;\n  height: 2rem;\n}\n\n/* min-width:0 : indispensable pour que le -webkit-line-clamp de l'apercu fonctionne en flex. */\n.opms__critere-memo-content {\n  flex: 1;\n  min-width: 0;\n}\n\n/* Apercu : exactement 2 lignes + \"...\". Triple garantie anti-fuite de la 3e ligne :\n   -webkit-line-clamp (le \"...\"), max-height = 2 x line-height (clip dur), overflow hidden.\n   Element sans padding + white-space normal (le \\n du texte se reduit a une espace ici). */\n.opms__critere-memo-preview {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  max-height: 3em; /* 2 x line-height(1.5) a font-size 1.4rem : coupe net 2 lignes (pas de fuite) */\n  color: #595959;\n  font-size: 1.4rem;\n  line-height: 1.5;\n}\n\n/* Override du tooltip de base (.opms__tooltip, width 300px) : large + retours a la ligne\n   conserves pour le texte long. Selecteur descendant (0,2,0) -> bat .opms__tooltip (0,1,0). */\n.opms__critere-memo .opms__tooltip {\n  width: min(760px, 92vw);\n  white-space: pre-line;\n  font-size: 1.4rem; /* plus gros que l'apercu (1.3rem) : lisible malgre la longueur */\n  line-height: 1.6;\n}\n\n.opms__critere-memo:hover .opms__tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n/* Note \"Pour memoire\" courte (formule financiere, ponderation synthese) : texte integral,\n   meme habillage que l'apercu des criteres techniques. */\n.opms__memo-note {\n  margin: 0 0 1.5rem;\n  color: #374151;\n  font-size: 1.3rem;\n  line-height: 1.5;\n  background: #f9fafb;\n  border-left: 3px solid #f97316;\n  padding: 0.85rem 1.1rem;\n  border-radius: 4px;\n}\n\n.opms__presta-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));\n  gap: 2rem;\n  /* Espace en haut : les badges pilule depassent de -12px et ne doivent pas coller au titre de section. */\n  margin-top: 1.75rem;\n  margin-bottom: 2rem;\n}\n\n.opms__presta-col {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  background-color: #fffdfc;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 2rem;\n}\n\n.opms__presta-col--disabled {\n  opacity: 0.55;\n}\n\n/* Badge centre en haut de carte (pilule). Gris par defaut, orange pour gagnant/accepte/signature. */\n.opms__presta-badge {\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #6b7280;\n  color: #fff;\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-weight: 600;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 2;\n  min-width: 192px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.opms__presta-badge--ok {\n  background-color: #f97316;\n}\n\n.opms__presta-header {\n  margin-bottom: 2rem;\n  background-color: rgba(194, 194, 194, 0.5);\n  border-radius: 10px;\n  padding: 1rem;\n  color: #2c3948;\n  text-align: center;\n}\n\n.opms__presta-header h3 {\n  margin: 0 0 0.5rem;\n  font-size: 1.8rem;\n  color: #2c3948;\n}\n\n.opms__presta-header span {\n  font-size: 1.4rem;\n  color: #6b7280;\n}\n\n.opms__field {\n  margin-bottom: 2rem;\n}\n\n.opms__field > label,\n.opms__field-label {\n  display: block;\n  color: #2c3948;\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 0.8rem;\n}\n\n.opms__readonly-text {\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  background-color: rgba(215, 217, 217, 0.2);\n  white-space: pre-wrap;\n  word-break: break-word;\n  margin-bottom: 1rem;\n}\n\n.opms__sep {\n  border: none;\n  border-top: 1px solid #004681;\n  opacity: 0.4;\n  margin: 1.5rem 0;\n}\n\n.opms__required {\n  color: #dc2626;\n  margin-left: 2px;\n}\n\n.opms__input {\n  width: 100%;\n  padding: 1.2rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 1rem;\n  color: #2c3948;\n  font-family: inherit;\n}\n\ntextarea.opms__input {\n  /* Hauteur pilotee par AutoGrowTextarea (scrollHeight) : la zone s'adapte au texte,\n     sans scroll interne ni poignee de resize. */\n  min-height: 4rem;\n  resize: none;\n  overflow: hidden;\n}\n\n.opms__input:disabled {\n  background-color: rgba(215, 217, 217, 0.2);\n  color: #6b7280;\n  cursor: not-allowed;\n}\n\n.opms__input--error {\n  border-color: #dc3545;\n}\n\n.opms__input--inactif {\n  background-color: rgba(215, 217, 217, 0.2);\n  color: #6b7280;\n  padding: 1.2rem;\n  border-radius: 10px;\n  text-align: center;\n}\n\n.opms__note-row {\n  margin-top: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.opms__note-row > label {\n  margin-bottom: 0;\n  white-space: nowrap;\n}\n\n.opms__note-select {\n  flex: 1;\n}\n\n.opms__note-out-of {\n  margin-left: 0.5rem;\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n.opms__presta-footer {\n  margin-top: auto;\n  padding-top: 16px;\n  border-top: 1px solid #eaeaea;\n}\n\n.opms__note-globale {\n  margin-top: 2rem;\n  text-align: center;\n  padding: 1.5rem;\n  background-color: rgba(218, 112, 39, 0.15);\n  border-radius: 0.8rem;\n  color: #2c3948;\n  font-weight: bold;\n}\n\n.opms__note-globale h4 {\n  font-size: 1.6rem;\n  margin: 0 0 1rem;\n  color: #2c3948;\n}\n\n.opms__note-value {\n  font-size: 2.4rem;\n  font-weight: 700;\n  color: #2c3948;\n}\n\n/* ===== Synthese (cartes cliquables) ===== */\n\n/* Mise en evidence du mieux-disant (retenu automatique par note globale) */\n.opms__presta-col--best {\n  border: 3px solid #f97316;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);\n}\n\n/* Ligne de notes ponderees : grille 40/60 (V1) */\n.opms__synthese-row {\n  display: grid;\n  grid-template-columns: 40% 60%;\n  gap: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n.opms__synthese-cell {\n  font-weight: 600;\n}\n\n/* Pilule de ponderation grise (55% / 45%) */\n.opms__ponderation-badge {\n  display: inline-block;\n  padding: 0.2rem 0.6rem;\n  border-radius: 1rem;\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-left: 0.5rem;\n  background-color: rgba(215, 217, 217, 0.4);\n  color: #595959;\n}\n\n.opms__note-detail {\n  font-size: 0.95rem;\n  color: #6b7280;\n  margin-left: 0.5rem;\n}\n\n.opms__classement {\n  margin-top: 0.8rem;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #f97316;\n}\n\n/* ===== Grille financiere (DPGF) ===== */\n\n.opms__articles-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 1rem;\n}\n\n.opms__articles-table th,\n.opms__articles-table td {\n  padding: 0.8rem;\n  text-align: left;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.opms__articles-table th {\n  background-color: #d7d9d940;\n  font-weight: 600;\n  color: #2c3948;\n}\n\n.opms__articles-table td:last-child {\n  text-align: right;\n}\n\n/* En-tete \"Prix HT\" aligne a droite, comme la colonne prix. */\n.opms__articles-table th:last-child {\n  text-align: right;\n}\n\n/* Specificite (td.classe) pour battre `.opms__articles-table td:last-child` (align droite\n   de la colonne prix) : le titre de groupe est un td colSpan=2, donc aussi last-child. */\n.opms__articles-table td.opms__articles-section {\n  background-color: #d7d9d940;\n  color: #2c3948;\n  text-align: left;\n  font-weight: 700;\n  font-size: 1.3rem;\n}\n\n.opms__article-numero {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.opms__article-code {\n  font-weight: 600;\n}\n\n/* Nom de l'article : debut affiche, tronque a \"…\" ; nom complet en tooltip au survol. */\n.opms__article-name {\n  position: relative;\n  color: #374151;\n  cursor: help;\n}\n\n.opms__tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: 5px;\n  width: 300px;\n  background-color: #595959;\n  color: #fff;\n  padding: 8px 12px;\n  border-radius: 4px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  font-size: 1rem;\n  font-weight: 400;\n  text-align: left;\n  white-space: normal;\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 0.2s, visibility 0.2s;\n  pointer-events: none;\n  z-index: 10;\n}\n\n.opms__article-name:hover .opms__tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n.opms__tooltip::before {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 10px;\n  border-width: 6px;\n  border-style: solid;\n  border-color: transparent transparent #595959 transparent;\n}\n\n.opms__total-row {\n  font-weight: 700;\n  font-size: 1.6rem;\n  text-align: right;\n  padding: 1rem;\n  background-color: rgba(215, 217, 217, 0.2);\n  border-radius: 4px;\n  margin-bottom: 2rem;\n}\n\n/* ===== Onglet Marché / Notifications et signatures ===== */\n\n/* Les sections du Marché sont enveloppées dans OperationAnalyseAccordion :\n   bordure, radius et padding du corps sont fournis par .opms__accordion / .opms__accordion-body.\n   .opms__marche-body reste un conteneur transparent (passthrough). */\n.opms__marche-body {\n  padding: 0;\n  /* Les marges verticales de freres adjacents FUSIONNENT dans un bloc : `.opms__marche-preview`\n     (margin-bottom 1.5rem) et `.opms__marche-sign-bottom` (margin-top 1.6rem) ne produisaient que\n     1.6rem au lieu de 3.1rem. Un contexte flex supprime cette fusion. Meme correction que la case BC\n     (`.bc-notif .section-content`). */\n  display: flex;\n  flex-direction: column;\n}\n\n/* Section « Préparation du MS » : recap read-only en grille responsive (label gris + valeur). */\n.opms__recap-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.2rem 2rem;\n}\n\n.opms__recap-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.opms__recap-label {\n  font-size: 1.2rem;\n  color: #6b7280;\n}\n\n.opms__recap-value {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #2c3948;\n  word-break: break-word;\n}\n\n.opms__recap-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n}\n\n/* Ancre de scroll du bouton « Prévisualiser le marché ». */\n.opms__marche-anchor {\n  scroll-margin-top: 1rem;\n}\n\n/* Section « Information aux candidats » : tableau retenu / non-retenus. */\n.opms__candidats {\n  margin-bottom: 1.5rem;\n}\n\n.opms__candidats-row {\n  display: grid;\n  grid-template-columns: 1.4fr 1.6fr 1.4fr 1.6fr;\n  gap: 1rem;\n  align-items: center;\n  padding: 0.8rem 0;\n  border-bottom: 1px solid #eaeaea;\n  font-size: 1.3rem;\n  color: #2c3948;\n}\n\n.opms__candidats-head {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #6b7280;\n  border-bottom: 2px solid #d7d9d9;\n}\n\n.opms__candidats-nom {\n  font-weight: 600;\n}\n\n.opms__candidats-mail {\n  word-break: break-all;\n}\n\n.opms__candidats-link {\n  background: none;\n  border: none;\n  padding: 0;\n  color: #f97316;\n  font: inherit;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.opms__candidats-action {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  align-items: flex-start;\n}\n\n.opms__candidats-error {\n  color: #b91c1c;\n  font-size: 1.1rem;\n}\n\n.opms__marche-signature > h4,\n.opms__marche-signature > h5 {\n  margin-top: 0;\n  color: #2c3948;\n}\n\n.opms__marche-preview {\n  margin-bottom: 1.5rem;\n}\n\n.opms__marche-pdf {\n  margin-top: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: #f5f5f5;\n}\n\n.opms__marche-iframe {\n  width: 100%;\n  height: 600px;\n  border: none;\n}\n\n.opms__marche-pdf-empty {\n  padding: 2rem;\n  text-align: center;\n  color: #666;\n}\n\n/* Preview PDF a 3/4 de la largeur : l'utilisateur peut scroller la page facilement autour. */\n.opms__marche-pdf--narrow {\n  width: 75%;\n}\n\n/* Bloc « Rappel des documents associés » (Contrat + 2 CCTP en cartes + carte-bouton profil). */\n.opms__marche-docs {\n  margin-bottom: 1.5rem;\n}\n\n/* Cartes documents + carte-bouton profil sur la meme ligne : grille a colonnes egales.\n   Les conteneurs internes de DocumentsList sont aplatis (display: contents) pour que ses cartes\n   ET la carte-bouton deviennent des items directs de CETTE grille (colonnes uniformes). */\n.opms__marche-docs-row {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  align-items: stretch;\n  gap: 1rem;\n}\n\n.opms__marche-docs-row .documents-list,\n.opms__marche-docs-row .documents-grid {\n  display: contents;\n}\n\n/* Libelle des cartes-documents : retour a la ligne (2 lignes) plutot que troncature \"...\" . */\n.opms__marche-docs .document-card-type {\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n}\n\n/* Carte-bouton « Voir les autres documents... » : reutilise l'habillage .document-card. */\n.opms__marche-doc-more {\n  cursor: pointer;\n  text-align: left;\n}\n\n.opms__marche-docs > h5 {\n  margin: 1.5rem 0 0.8rem;\n  color: #2c3948;\n}\n\n/* Signataire en bas de la section signature + bouton « Signer et notifier ». */\n.opms__marche-signataire {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  margin-top: 1rem;\n}\n\n.opms__marche-signataire-line {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n  margin: 0;\n  font-size: 1.3rem;\n  color: #2c3948;\n}\n\n.opms__marche-signataire-input {\n  min-width: 220px;\n}\n\n/* Bouton « Signer et notifier » : aligne a droite, largeur naturelle (pas pleine largeur). */\n.opms__marche-signataire-action {\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* Le composant Button a `align-self: stretch` global : dans la barre du bas (a cote du PrintButton\n   plus haut) il s'etire en hauteur, alors que dans le bloc signataire il garde sa hauteur naturelle.\n   On force `center` partout -> meme taille du bouton « Signer et notifier » aux 3 emplacements. */\n.opms__marche-sign-top .button,\n.opms__marche-sign-bottom .button,\n.opms__marche-signataire-action .button,\n.opms__actions .button {\n  align-self: center;\n}\n\n.opms__marche-sign-direct,\n.opms__marche-request {\n  margin-top: 1.5rem;\n}\n\n.opms__marche-request {\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n}\n\n.opms__marche-request-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.opms__marche-request-history {\n  margin-top: 2rem;\n  padding: 1.5rem;\n  background-color: #d4edda;\n  border-radius: 12px;\n  border-left: 6px solid #28a745;\n}\n\n.opms__marche-request-history > h5 {\n  color: #155724;\n  margin: 0 0 1.25rem;\n}\n\n.opms__marche-request-entry {\n  padding: 1rem 1.25rem;\n  background-color: rgba(255, 255, 255, 0.6);\n  border-radius: 8px;\n  color: #155724;\n  margin-bottom: 1rem;\n}\n\n.opms__marche-request-label {\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.opms__marche-request-date {\n  font-size: 0.95rem;\n  opacity: 0.85;\n}\n\n.opms__marche-complete {\n  text-align: center;\n}\n\n.opms__marche-success h4 {\n  color: #2c3948;\n  margin: 1rem 0;\n}\n\n.opms__marche-actions {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.opms__marche-notify {\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #ddd;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n/* Modale d'aperçu du mail de notification */\n.opms__marche-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.opms__marche-modal {\n  position: relative;\n  background: #fff;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 80vw;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.opms__marche-modal-bar {\n  position: sticky;\n  top: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  padding: 10px 20px;\n  background: rgba(255, 255, 255, 0.95);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n}\n\n.opms__marche-notified {\n  color: #10b981;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* Titre / date d'envoi de la popup « Voir le message » + actions (PDF / Fermer). */\n.opms__marche-modal-title {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #2c3948;\n}\n\n.opms__marche-modal-actions {\n  display: flex;\n  gap: 0.6rem;\n}\n\n/* « Signer et notifier » duplique en haut de section : aligne a droite. */\n.opms__marche-sign-top {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 1rem;\n}\n\n/* Pendant BAS de `.opms__marche-sign-top` : meme alignement, mais la marge passe EN HAUT — le bouton\n   suit desormais la previsualisation au lieu de la preceder.\n   Espacement calque sur la reference BC (`.bc-notif__actions` : gap 1rem, margin-top 1.6rem) pour que\n   le meme bouton respire pareil d'un module a l'autre. Sert aux DEUX cases MS (acheteur et\n   prestataire), qui partagent cette feuille. */\n.opms__marche-sign-bottom {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1.6rem;\n}\n\n/* --- Analyse IA en cours : skeleton (shimmer) sur les champs commentaire / note ---\n   Reutilise la brique .opms-sk (shimmer, definie plus haut). Geometrie calee sur le vrai\n   champ pour eviter le saut de mise en page a l'arrivee des donnees. */\n.opms-sk-line {\n  height: 1.2rem;\n  width: 100%;\n}\n\n.opms-sk-line--short {\n  width: 60%;\n}\n\n/* Commentaire : meme min-height que textarea.opms__input (4rem), 3 lignes shimmer. */\n.opms-sk-comment {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  min-height: 4rem;\n  padding: 0.4rem 0;\n}\n\n/* Note : occupe la place du select (flex:1 via .opms__note-select), hauteur du champ. */\n.opms-sk-note {\n  height: 4.2rem;\n}\n\n/* Note technique globale : meme gabarit que .opms__note-value (2.4rem), centre. */\n.opms-sk-noteglobale {\n  width: 6rem;\n  height: 2.4rem;\n  margin: 0 auto;\n}\n\n/* Synthese en attente de l'analyse IA. */\n.opms-sk-synthese {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  padding: 2rem 1rem;\n}\n\n/* --- Refonte Descriptif administratif (onglet Consultation) : sous-sections Acheteur /\n   Operation / Particularites + utilitaire pleine largeur dans la grille. --- */\n.opms__descriptif-admin .opms__sous-section {\n  margin-bottom: 2.4rem;\n}\n.opms__descriptif-admin .opms__sous-section:last-child {\n  margin-bottom: 0;\n}\n.opms__sous-section-titre {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #000;\n  margin: 0 0 1.2rem;\n  padding-bottom: 0.6rem;\n}\n.opms__descriptif-admin .opms__span-full {\n  grid-column: 1 / -1;\n}\n\n/* Grille 12 colonnes des sous-blocs (fidele au PDF : lignes de 3 / 4 / 2 champs via les spans). */\n.opms__descriptif-admin .opms__admin-grid {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 1.2rem 2rem;\n  align-items: start;\n}\n@media (max-width: 900px) {\n  .opms__descriptif-admin .opms__admin-grid > * {\n    grid-column: 1 / -1 !important;\n  }\n}\n\n/* Champs editables a la MEME taille que les read-only (.input-inactif) : meme box-model.\n   La bordure transparente du read-only egalise sa hauteur avec la bordure 1px de l'input. */\n.opms__descriptif-admin .form-group input,\n.opms__descriptif-admin .form-group textarea,\n.opms__descriptif-admin .form-group select,\n.opms__descriptif-admin .form-group .input-inactif {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 1.2rem;\n  border-radius: 10px;\n  font: inherit;\n  line-height: 1.4;\n}\n/* Champs sur une ligne (input, select, read-only) : meme hauteur mini -> le select colle aux inputs. */\n.opms__descriptif-admin .form-group input,\n.opms__descriptif-admin .form-group select,\n.opms__descriptif-admin .form-group .input-inactif {\n  min-height: 4.6rem;\n}\n.opms__descriptif-admin .form-group input,\n.opms__descriptif-admin .form-group textarea,\n.opms__descriptif-admin .form-group select {\n  border: 1px solid #e5e7eb;\n  color: #2c3948;\n  background: #fff;\n}\n.opms__descriptif-admin .form-group .input-inactif {\n  border: 1px solid transparent;\n}\n/* Le champ adresse est etroit (span 3) : la liste d'autocomplete s'elargit au-dela de la cellule\n   pour afficher les adresses completes sans troncature. */\n.opms__descriptif-admin .autocomplete-list {\n  right: auto;\n  min-width: 36rem;\n  max-width: 60rem;\n  max-height: 32rem;\n}\n.opms__descriptif-admin .autocomplete-list li {\n  font-size: 1.3rem;\n  padding: 1rem 1.2rem;\n  white-space: normal;\n  line-height: 1.35;\n}\n\n/* Chevron custom du select (le fond blanc masque la fleche native). */\n.opms__descriptif-admin .form-group select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%23595959' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 1.2rem center;\n  padding-right: 3.6rem;\n  cursor: pointer;\n}\n\n/* Modale des criteres = AccueilModal contrainte : largeur 72rem, hauteur au contenu (max 85vh).\n   Elle apporte deja la croix header, le clic-overlay et Escape. */\n.accueil-modal.opms__critere-modal {\n  width: min(72rem, calc(100vw - 2rem));\n  height: auto;\n  max-height: 85vh;\n}\n.opms__critere-modal .accueil-modal-body {\n  padding: 2rem 2.4rem;\n  /* Scrollbar TOUJOURS visible (sinon overlay auto-hide sur Mac -> on ne voit pas le contenu en bas). */\n  overflow-y: scroll;\n  scrollbar-width: thin;\n  scrollbar-color: #b0b0b0 #f1f1f1;\n}\n.opms__critere-modal .accueil-modal-body::-webkit-scrollbar {\n  width: 10px;\n}\n.opms__critere-modal .accueil-modal-body::-webkit-scrollbar-thumb {\n  background: #b0b0b0;\n  border-radius: 5px;\n}\n.opms__critere-modal .accueil-modal-body::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* \"Lire la suite\" : lien inline dans un champ read-only (ouvre la modale ValidationPopUp des criteres). */\n.opms__lire-la-suite {\n  background: none;\n  border: none;\n  padding: 0;\n  color: #f97316;\n  font: inherit;\n  text-decoration: underline;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n/* Rappel criteres/ponderations (bas du Descriptif procedural) : 4 champs read-only span-3 sur UNE\n   ligne (4-across), de MEME taille. Le titre le plus long ne tient pas sur une ligne a taille normale\n   dans un span-3 -> police reduite (1.05rem) + nowrap (pas d'ellipsis). Boites a hauteur fixe = 2\n   lignes ; le 1er champ est tronque cote donnee (critereTechniqueApercu) pour tenir en ~2 lignes en\n   gardant \"lire la suite\" inline visible. */\n/* Titres a taille classique : le 1er (le plus long) peut passer sur 2 lignes. On reserve 2 lignes de\n   hauteur pour les 4 labels (min-height + line-height fixe) -> les 4 boites restent alignees meme quand\n   un seul titre wrap. */\n.opms__rappel-champ > label {\n  display: block;\n  line-height: 1.3;\n  min-height: 2.6em;\n}\n.opms__descriptif-admin .opms__rappel-champ .input-inactif {\n  height: 6.6rem;\n  min-height: 6.6rem;\n  overflow: hidden;\n}\n\n/* \"(GMT Paris)\" affiche DANS le champ date-heure : le wrapper porte la bordure/le box-model,\n   l'input est sans bordure a l'interieur, le suffixe est colle a droite dans la meme boite. */\n.opms__datetime-gmt {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: #fff;\n  padding-right: 1.2rem;\n  min-height: 4.6rem;\n}\n/* Input a l'interieur du wrapper : sans bordure ni hauteur propre (le wrapper porte le box-model).\n   Le 2e selecteur bat la regle harmonisee `.opms__descriptif-admin .form-group input` (contexte procedural). */\n.opms__datetime-gmt input,\n.opms__descriptif-admin .form-group .opms__datetime-gmt input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  min-height: 0;\n  background: transparent;\n  font: inherit;\n  padding: 1.2rem;\n  color: #2c3948;\n  outline: none;\n}\n.opms__datetime-gmt-suffix {\n  color: #6b7280;\n  font-size: 1.3rem;\n  white-space: nowrap;\n}\n/* Etat erreur (champ date obligatoire vide au lancement) : bordure rouge, meme code que les inputs .error. */\n.opms__datetime-gmt.error {\n  border-color: #dc2626;\n}\n\n/* Compteur de caracteres (guard \"une phrase\" = 255) sous les champs texte descriptifs des blocs\n   Acheteur & Operation. Meme rendu que le compteur du profil (.char-count). */\n.opms__char-count {\n  display: block;\n  text-align: right;\n  font-size: 1.1rem;\n  color: #6b7280;\n  margin-top: 0.3rem;\n}\n\n/* \"Documents liés à la consultation\" : DocumentsList (CCTP cliquables) + champ des pieces specifiques\n   qui prend l'espace restant, fondus dans un seul bloc sous un label unique (pas deux colonnes separees). */\n/* Le champ des pieces specifiques est le contenu du trailingCard de DocumentsList (qui gere la sizing\n   \"2 places\" via .documents-grid-trailing). Ici on ne fait que le VISUEL : fond gris read-only, bordure\n   de carte, meme hauteur mini. Son contenu scrolle dans un inner absolu -> ne dicte pas la hauteur. */\n.opms__docs-consultation-champ {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  min-height: 88px;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.75rem;\n  background: rgba(215, 217, 217, 0.2);\n  overflow: hidden;\n}\n/* Label du champ (design system : header section #595959) au-dessus du contenu reel. */\n.opms__docs-consultation-champ-label {\n  flex-shrink: 0;\n  padding: 1rem 1.25rem 0.4rem;\n  color: #595959;\n  font-size: 1.3rem;\n  font-weight: 600;\n  line-height: 1.3;\n}\n/* Contenu reel : prend la place restante sous le label et scrolle (ne dicte pas la hauteur de la carte). */\n.opms__docs-consultation-champ-inner {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  padding: 0 1.25rem 1.125rem;\n  color: #374151;\n  line-height: 1.4;\n  white-space: pre-wrap;\n}\n\n/* Section Prolongation : aligne le padding du corps de l'accordeon (1.2rem par defaut) sur celui des\n   autres sections de l'onglet Consultation (4rem), sans toucher le composant partage avec l'Analyse. */\n.opms__prolongation-section .opms__accordion-body {\n  padding: 4rem;\n}\n\n/* Onglet \"Notifications et signatures\" : ses sections sont passees sur SectionPliable (comme les\n   onglets BC), le padding vient donc de `.section-pliable-content` — 1.5rem par defaut. On l'aligne\n   sur la reference BC, qui fait 4rem via `.consultation-bc .section-pliable-content`.\n   La chaine d'espacement du bouton de telechargement devient alors identique des deux cotes :\n     padding de section 4rem  ·  marge sous l'apercu 1.5rem  ·  marge au-dessus du bouton 1.6rem\n   Scope a `.opms__marche` — racine des DEUX cases MS (acheteur et prestataire). */\n.opms__marche .section-pliable-content {\n  padding: 4rem;\n}\n\n/* Section \"Prolongation de délai\" (onglet Consultation). */\n.opms__prolongation {\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n  margin-top: 1.6rem;\n}\n.opms__prolongation .form-group {\n  max-width: 48rem;\n}\n.opms__prolongation-historique h4 {\n  margin: 0 0 0.8rem;\n  color: #595959;\n  font-size: 1.6rem;\n}\n.opms__prolongation-historique ul {\n  margin: 0;\n  padding-left: 1.8rem;\n  line-height: 1.6;\n  color: #374151;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
